// eslint-disable-next-line import/prefer-default-export
export const getInitials = (cString) => {
  if ((cString >= 'A' && cString <= 'Z') ||
    (cString >= 'a' && cString <= 'z') || cString === 'ñ' || cString === 'Ñ') {
    const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
    const strFirstTwo = val.slice(0, 2);
    const final = strFirstTwo.join('');
    return final.toUpperCase();
  }
  return cString;
};

export const ucwords = (str) => {
  return `${str}`.replace(/^(.)|\s+(.)/g,  ($1) => {
      return $1.toUpperCase()
    })
}

export const currency = new Intl.NumberFormat('en-PH', {
	minimumFractionDigits: 2,
  });